module.exports = __webpack_public_path__ + "static/media/day04.0589bb90.jpg";